/** Layout rules for saved lesson content, shared by editor and learner views. */
export const LESSON_CONTENT_STYLES = `
/* Empty paragraphs have an editing-only trailing <br> in Tiptap. Reserve a
   line in saved HTML as well, including in panels, cards and table cells. */
p:empty { min-height:1.2em; min-height:1lh; }
`;
